import { type FunctionComponent, type ReactNode } from 'react';
import { useRelayEnvironment } from 'react-relay';
import { Header } from 'dibs-elements/exports/Header.tsx';
import Logo from 'dibs-logo/exports/Logo.ts';
import { Well } from 'dibs-elements/exports/Well.tsx';
import DealerLoginCookieDisclaimer from './dealer/DealerLoginCookieDisclaimer.tsx';

import styles from './styles/LoginWell.scss';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    children: ReactNode;
    heading: ReactNode;
    subtitle?: ReactNode;
    hasMessage?: boolean;
    showCookieDisclaimer?: boolean;
};

const LoginWell: FunctionComponent<Props> = ({
    children,
    heading,
    subtitle,
    hasMessage,
    showCookieDisclaimer,
}) => {
    const environment = useRelayEnvironment();

    return (
        <div
            className={classnames(
                styles.loginWellWrapper,
                dibsCss.flex,
                dibsCss.flexCol,
                dibsCss.itemsCenter,
                dibsCss.justifyCenter,
                {
                    [styles.hasMessage]: hasMessage,
                }
            )}
        >
            <Well className={classnames(styles.loginWell, dibsCss.wFull, dibsCss.mxAuto)}>
                <div
                    className={classnames(
                        dibsCss.flex,
                        dibsCss.flexCol,
                        dibsCss.itemsCenter,
                        dibsCss.mtSmall,
                        dibsCss.mbLarge
                    )}
                >
                    <Logo className={classnames(styles.dibsLogo, dibsCss.mbSmall)} />
                    <Header title={heading} subtitle={subtitle} />
                </div>
                {children}
            </Well>
            {showCookieDisclaimer && environment && (
                <DealerLoginCookieDisclaimer environment={environment} />
            )}
        </div>
    );
};

export default LoginWell;
